'use strict';

var _ = require('lodash');
function ProfileChartAddFlightModalDataService($q, dataRetrieverService, constants) {
  function getDataFromDataRetrievers() {
    var dataRetriever = dataRetrieverService.getDataRetriever(constants.FLIGHT_SCREEN, constants.CABIN_MODE, constants.PROFILE_CHART_ADD_FLIGHT_PANEL_DROPDOWNS);
    dataRetriever = _.cloneDeep(dataRetriever);
    dataRetriever.defaultSortDefer = $q.all();
    dataRetriever.defaultSortCriteriaPromise = dataRetriever.defaultSortDefer.promise;
    return dataRetriever.retrieveComponentData();
  }
  function getDataFromRowsVariable(flightSummaryRows) {
    return $q.when(flightSummaryRows || []);
  }
  function getRawData(screenMode, flightSummaryRows) {
    switch (screenMode) {
      case constants.FLIGHT_ANALYSIS_MODE:
        return getDataFromDataRetrievers();
      case constants.FLIGHT_MANAGEMENT_MODE:
        return getDataFromRowsVariable(flightSummaryRows);
      default:
        return $q.when([]);
    }
  }
  function transformData(data) {
    return _.chain(data).reduce(function (result, legCabinRow) {
      if (_.indexOf(result.legsList, legCabinRow.leg) === -1) {
        result.legsList.push(legCabinRow.leg);
      }
      if (legCabinRow.flightNumber && _.indexOf(result.flightNumbersList, '' + legCabinRow.flightNumber) === -1) {
        result.flightNumbersList.push('' + legCabinRow.flightNumber);
      }
      if (_.indexOf(result.departureDatesList, legCabinRow.flightDepartureDateMoment) === -1) {
        result.departureDatesList.push(legCabinRow.flightDepartureDateMoment);
      }
      return result;
    }, {
      legsList: [],
      flightNumbersList: [],
      departureDatesList: []
    }).mapValues(function (valuesArray, key) {
      if (key === 'flightNumbersList') {
        return _.sortBy(valuesArray, function (flightNumber) {
          return parseInt(flightNumber);
        });
      } else {
        return _.sortBy(valuesArray);
      }
    }).value();
  }
  function getDropdownData(screenMode, flightSummaryRows) {
    return getRawData(screenMode, flightSummaryRows).then(function (data) {
      return transformData(data);
    });
  }
  function verifySelection(leg, flightNumber, departureDateMoment, screenMode, flightSummaryRows) {
    return getRawData(screenMode, flightSummaryRows).then(function (data) {
      return _.filter(data, function (row) {
        return row.leg === leg && row.flightNumber === _.toNumber(flightNumber) && row.flightDepartureDateMoment.isSame(departureDateMoment);
      });
    });
  }
  return {
    getDropdownData: getDropdownData,
    verifySelection: verifySelection
  };
}
ProfileChartAddFlightModalDataService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = ProfileChartAddFlightModalDataService;